import { on } from 'delegated-events'

const fn = {
  init: () => {
    on('click', '[data-fund-view]', fn.handleViewToggle)
  },

  handleViewToggle: (e) => {
    const button = e.target.closest('[data-fund-view]')
    const type = button.dataset.fundView
    const wrapper = document.querySelector('.funds-wrapper')

    document.querySelector('[data-fund-view].is-active').classList.remove('is-active')
    button.classList.add('is-active')

    wrapper.classList.remove('as-list')
    wrapper.classList.remove('as-grid')

    wrapper.classList.add(`as-${type}`)
  },
}

export default {
  can: () => document.body.classList.contains('pagetype-fundspage') || document.body.classList.contains('pagetype-fundingprojectspage') || document.body.classList.contains('pagetype-organizationspage'),
  run: fn.init,
}
